import React from 'react'

import { TabButton, Tabs } from './style'
import { useHistoryTabs } from './useHistoryTabs'

const HistoryTabs = () => {
    const { activeTab, tabs, setActiveTab } = useHistoryTabs()

    return (
        <Tabs>
            {tabs.map((tab) => (
                <TabButton
                    key={tab.id}
                    type="button"
                    $active={activeTab === tab.id}
                    onClick={() => setActiveTab(tab.id)}
                >
                    {tab.label}
                </TabButton>
            ))}
        </Tabs>
    )
}

export default HistoryTabs
